import { Attr, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


export type NormalAttr = { normal: Attr };

export class SetNormal<T extends NormalAttr> extends IndexedMeshWriter<T> {

    x: number;
    y: number;
    z: number;

    /** The mesh to  */
    writer: IndexedMeshWriter<T>;

    /**
     * Note that this does not copy the input mesh data; it acts in place. You
     * could pass a `Clone` mesh writer if you want to use the underlying
     * writer instance in another pipeline.
     */
    constructor(x: number, y: number, z: number, writer: IndexedMeshWriter<T>) {
        super();
        this.x = x;
        this.y = y;
        this.z = z;
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T> {
        const result = this.writer.computeAttributeCounts();

        if(result.attrs.normal == null) {
            result.attrs.normal = new Attr(3);
            result.attrs.normal.count = result.position.count;
        }

        return result;
    }

    computeMeshData(result: IndexedMesh<T>): void {
        this.writer.computeMeshData(result);

        const
            norm = result.attrs.normal.data;

        let i = 0;
        while(i < norm.length) {
            norm[i++] = this.x;
            norm[i++] = this.y;
            norm[i++] = this.z;
        }
    }
}
